import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './ios-compat.css'; // iOS & cross-browser compatibility fixes
import App from './App';
import reportWebVitals from './reportWebVitals';
import { installAuthFetch } from './utils/authFetch';

installAuthFetch();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
